import React from "react";
import { connect } from "react-redux";
import { removeNotification, removeNotificationDelayed } from "actions/notification";
import cx from "classnames";
import isArray from "lodash/isArray";
import PropTypes from "prop-types";
import NotificationError from "rialto-icons/NotificationError";
import NotificationInfo from "rialto-icons/NotificationInformation";
import NotificationSuccess from "rialto-icons/NotificationSuccess";
import NotificationWarning from "rialto-icons/NotificationWarning";

import styles from "./Notifications.css";

export class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: props.notifications || [],
    };
    this.addNotifications = this.addNotifications.bind(this);
    this.cleanUpNotifications = this.cleanUpNotifications.bind(this);
    this.notificationIcon = {
      error: NotificationError,
      warning: NotificationWarning,
      success: NotificationSuccess,
      info: NotificationInfo,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.addNotifications(nextProps.notifications);
    this.cleanUpNotifications(nextProps.notifications);
  }

  addNotifications(notifications) {
    notifications.forEach((notification) => {
      if (
        !this.state.notifications.some(
          (n) =>
            (n.title === notification.title && n.message === notification.message) ||
            n.id === notification.id
        )
      ) {
        this.setState({
          notifications: [...this.state.notifications, notification],
        });
        this.props.dismissNotificationDelayed(notification.id);
      }
    });
  }

  cleanUpNotifications(notifications) {
    this.state.notifications.forEach((notification) => {
      if (!notifications.some((n) => notification.id === n.id)) {
        this.setState({
          notifications: this.state.notifications.filter((n) => n.id !== notification.id),
        });
      }
    });
  }

  render() {
    const message = (notification) =>
      isArray(notification.message) ? notification.message.join("<br />") : notification.message;

    return (
      <div className={styles.container}>
        {this.state.notifications.map((notification, index) => {
          const Icon = this.notificationIcon[notification.type];

          return (
            <div
              className={cx(styles.notification, styles[notification.type])}
              key={index}
              onClick={() => this.props.dismissNotification(notification.id)}
            >
              <Icon className={styles.icon} size="xlarge" />
              <div>
                <h1>{notification.title}</h1>
                {message(notification) && (
                  <div dangerouslySetInnerHTML={{ __html: message(notification) }} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

Notifications.propTypes = {
  notifications: PropTypes.arrayOf(
    // eslint-disable-line
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
      type: PropTypes.string,
    })
  ),
  dismissNotification: PropTypes.func,
  dismissNotificationDelayed: PropTypes.func,
};

const mapStateToProps = (state) => ({
  notifications: state.notifications,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dismissNotification: (notificationID) => dispatch(removeNotification(notificationID)),
  dismissNotificationDelayed: (notificationID) =>
    dispatch(removeNotificationDelayed(notificationID, ownProps.dismissAfter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
